import React from 'react';

export default function HackingSectionCallToAction9() {
    return (
        <React.Fragment>
            <>
                <section className="py-20">  <div className="container px-4 mx-auto">    <div className="flex flex-wrap items-center -mx-4">      <div className="w-full md:w-1/2 px-4 order-1 md:order-0">        <img className="w-full object-cover rounded-lg" src="https://static.shuffle.dev/uploads/files/9d/9d10ed0533a2f5a309eabf70e599971ed8a7e37a/Frame.png" alt />    </div>      <div className="w-full md:w-1/2 px-4 md:order-1 mb-12 md:mb-0">        <div className="lg:max-w-md lg:ml-auto">          <h2 className="mb-4 lg:mb-8 text-4xl lg:text-5xl font-bold font-heading">S0 内测招募中</h2>          <p className="mb-6 text-lg text-gray-500 leading-loose">            预计时间 8/16 - 8/18            <br />            目前还在筹备阶段            <br />            有意向可以报名参加        </p>          <a className="inline-block px-6 py-2 text-sm text-white font-bold leading-loose bg-gray-600 hover:bg-gray-700 rounded transition duration-200" href="#">报名参加</a>      </div>    </div>  </div></div></section>


            </>
        </React.Fragment>
    );
}

